import { Skeleton, TableCell } from "@mui/material";
import {TableHeaderProps} from "./TableTypes";
import {useMemo} from "react";

interface ProjectTableCellProps<T extends {id:string}> {
    header:TableHeaderProps<T>
    row:T
    loading?: boolean
}

const sx = {
    transition: 'all 0.3s ease-in-out',
    '@media (max-width: 1200px)': {
        padding: '8px 4px'
    }
}

export function ProjectTableCell<T extends {id:string}>({header, row, loading}:ProjectTableCellProps<T>) {
    const content = useMemo(() => {
        return header.render(row);
    }, [header, row])
    return <TableCell
        sx={sx}
        align={header.alignment || "left"}
        className={header.className}
    >
        {loading ? <Skeleton/> : content}
    </TableCell>
}